import { FindClinicians } from "@/features/patient/appointments/components/find/find-clinicians";

function PatientFindAppointments() {
    return (
        <>
            <h1 className="sr-only">Find clinicians</h1>
            <FindClinicians />
        </>
    );
}

export default PatientFindAppointments;
